import React, { useState } from 'react'
import "./style/Nav.css"
import { Link } from "react-router-dom"

export default function Nav({ onSearch, searchValue }) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false)
  const [searchTerm, setSearchTerm] = useState(searchValue || '')

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen)
  }

  const handleSearchChange = (e) => {
    const value = e.target.value
    setSearchTerm(value)
    // Real-time search
    if (onSearch) {
      onSearch(value)
    }
  }

  const handleSearchSubmit = (e) => {
    e.preventDefault()
    if (onSearch) {
      onSearch(searchTerm)
    }
    setIsSidebarOpen(false)
  }

  return (
    <>
      {/* First Row - Logo Only (Center) */}
      <div className="logo-row">
        <div className="logo">
          <h3>APKNU.COM</h3>
        </div>
      </div>

      {/* Second Row - Side Button + Navigation + Search */}
      <div className="nav-search-row">
        {/* Side Button (Mobile) */}
        <button className="side-button" onClick={toggleSidebar}>
          ☰
        </button>

        {/* Navigation Links */}
        <div className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/aboutus">About Us</Link>
          <Link to="/contact">Contact Us</Link>
          <Link to="/privacypolicy">Privacy Policy</Link>
          <Link to="/disclamier">Disclaimer</Link>
        </div>

        {/* Search Bar */}
        <div className="search-container">
          <form onSubmit={handleSearchSubmit}>
            <input 
              type="text" 
              placeholder="Search apps by title..." 
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <button type="submit">🔍</button>
          </form>
        </div>
      </div>

      {/* Sidebar */}
      <div className={`sidebar ${isSidebarOpen ? 'open' : ''}`}>
        <button className="close-btn" onClick={toggleSidebar}>✕</button>
        <div className="sidebar-logo">
          <h3>APKNU.com</h3>
        </div>
        <nav className="sidebar-nav">
          <Link to="/" onClick={toggleSidebar}>Home</Link>
          <Link to="/aboutus" onClick={toggleSidebar}>About Us</Link>
          <Link to="/contact" onClick={toggleSidebar}>Contact Us</Link>
          <Link to="/privacypolicy" onClick={toggleSidebar}>Privacy Policy</Link>
          <Link to="/disclamier" onClick={toggleSidebar}>Disclaimer</Link>
        </nav>
        {/* Search in Sidebar */}
        <div className="sidebar-search">
          <form onSubmit={handleSearchSubmit}>
            <input 
              type="text" 
              placeholder="Search apps..." 
              value={searchTerm}
              onChange={handleSearchChange}
            />
            <button type="submit">🔍</button>
          </form>
        </div>
      </div>

      {/* Overlay */}
      {isSidebarOpen && <div className="overlay" onClick={toggleSidebar}></div>}
    </>
  )
}